import React from "react";
import { Tooltip } from "antd";
import TSTable from "../../common/TSTable";
import { dateToHumanString, formatComma, toFixed } from "../../frameworks/Util";
import { TANK_STATUS_TH } from "../../constants/string";
import { URL_SALE } from "../../constants/urls";
import ReportButton from "../common/ReportButton";
import ErrorMessages from "../../common/ErrorMessages";

export default function ReportSaleOrderTableSkim(props) {
  const { url } = props;
  const [errorMessages, setErrorMessages] = React.useState(null);

  const tableRef = React.useRef();

  
  const columns = [
    {
      title: 'Action',
      dataIndex: 'id',
      width: 80,
      key: 'id',
      render: (value, original) => 
        <center>
          <div style={{ textAlign: 'center' }} onClick={(e) => e.stopPropagation()}>
            <ReportButton
              url={`${url}${value}/`} 
              tooltip={'พิมพ์รายงาน'}
              sentError={(e) => setErrorMessages(e)}
            />
          </div>
        </center>
    },
    {
      title: 'วันที่',
      dataIndex: 'order_date',
      key: 'order_date',
      render: (value) => dateToHumanString(value),
    },
    {
      title: 'Contract No.',
      dataIndex: 'order_no',
      key: 'order_no',
      searcher : true,
    },
    {
      title: 'ชื่อลูกค้า',
      dataIndex: 'buyer_name',
      key: 'buyer_name',
      searcher : true,  
    },
    {
      title: 'สินค้าที่ต้องการ',
      dataIndex: 'product_name',
      key: 'product_name',
    },
    {
      title: 'Shipment',
      dataIndex: 'shipment',
      key: 'shipment',
    },
    {
      title: 'ปริมาณสั่งซื้อ (kg)',
      dataIndex: 'require_weight',
      key: 'require_weight',
      render: (value) => <center>{formatComma(value)}</center>,
    },
    {
      title: 'ปริมาณสั่งซื้อ (ก้อน)',
      dataIndex: 'require_amount',
      key: 'require_amount',  
      render: (value) => <center>{formatComma(value)}</center>,
    },
  ];


  return (
    <>
      <ErrorMessages message={errorMessages}/>
      <TSTable
        ref={tableRef}
        columns={columns}
        size={'small'}
        url={URL_SALE.SKIM_SALE_ORDER}
      />
    </>
  )
}